
//Data imports
import adminTrunk from '@/router/mt-admin-trunk.js';
import contractsTrunk from '@/router/mt-contracts-trunk.js';
import customerTrunk from '@/router/mt-customer-trunk.js';
import dashboardTrunk from '@/router/mt-dashboard-trunk.js';
import jobTrunk from '@/router/mt-job-trunk.js';
import mypageTrunk from '@/router/mt-mypage-trunk.js';
import partnerTrunk from '@/router/mt-partner-trunk.js';
import pimTrunk from '@/router/mt-pim-trunk.js';
import plannerTrunk from '@/router/mt-planner-trunk.js';

//View and component imports
import HeaderCardPage from '@/components/Sections/Containers/HeaderCardsContainer.vue';
import About from '@/views/landingpages/AboutPage.vue';
import Logout from '@/views/landingpages/Logout.vue';
import NotFound from '@/views/landingpages/NotFound.vue';
import PageParseRedirect from '@/views/landingpages/PageParseRedirect.vue';
import QrCodes from '@/views/landingpages/QrCodes.vue';
import SearchResults from '@/views/landingpages/SearchResults.vue';

//Export item
const root = [
    {
        meta: {
            display: { key: "servicesystem.pages.page_titles.home" },
            icon: "$home",
            overrides: {
                sidebar: false,
            }
        },
        path: '/',
        name: 'Home',
        redirect: { name: 'Dashboard' },
        component: HeaderCardPage
    },
    dashboardTrunk,
    mypageTrunk,
    jobTrunk,
    plannerTrunk,
    contractsTrunk,
    pimTrunk,
    customerTrunk,
    partnerTrunk,
    adminTrunk,
    {
        meta: {
            display: { key: "servicesystem.pages.page_titles.search_results" },
            icon: 'mdi-text-search-variant',
            overrides: {
                sidebar: false,
            }
        },
        name: 'SearchResults',
        path: '/search-results/:jobId?',
        component: SearchResults
    },
    {
        meta: {
            display: { key: "servicesystem.pages.page_titles.redirect" },
            icon: '$redirect',
            overrides: {
                sidebar: false,
            }
        },
        name: 'Redirect',
        path: '/auto-redirect',
        component: PageParseRedirect
    },

    {
        meta: {
            display: { key: "servicesystem.pages.page_titles.not_found" },
            icon: '$redirect',
            overrides: {
                sidebar: false,
            }
        },
        path: '*',
        component: NotFound
    },

    {
        meta: {
            display: { key: "servicesystem.pages.page_titles.about" },
            icon: '$about',
            overrides: {
                sidebar: false,
            }
        },
        name: 'About',
        path: "/about",
        component: About
    },

    {
        meta: {
            display: 'QrCodes',
            icon: 'mdi-qrcode',
            overrides: {
                sidebar: false,
            }
        },
        name: 'QrCodes',
        path: "/qr-codes",
        component: QrCodes
    },

    {
        meta: {
            display: 'Logout',
            icon: 'mdi-logout-variant',
            overrides: {
                sidebar: false,
            }
        },
        name: 'Logout',
        path: "/logout",
        component: Logout
        
    }
];



export default root;